<template >
  <div class="formPosition" v-role="roles">
    <!--====== COMPONENTE EXTERNO PARA O LOADING EFFECT ==========-->
    <loading  v-if="isLoading"/>
    <!--====== FIM COMPONENTE EXTERNO PARA O LOADING EFFECT ==========-->

    <!--====== CARD PRINCIPAL EXIBIDO NA TELA ==========-->
    <template>
      <v-container class="grey lighten-5">
        <v-row style="align-items: center;">
          <v-col cols="2" sm="2" md="2"><span>Selecione a classe </span> <v-icon large color="green darken-2">forward</v-icon></v-col>

          <v-col cols="7" sm="7" md="7" class="text-center">
            <v-btn @click="classe(1)" class="ma-2" outlined color="indigo"><v-icon small color="primary">filter_1</v-icon> 10ª classe</v-btn>
            <v-btn @click="classe(2)" class="ma-2" outlined color="indigo"><v-icon small color="primary">filter_2</v-icon> 11ª classe</v-btn>
            <v-btn @click="classe(3)" class="ma-2" outlined color="indigo"><v-icon small color="primary">filter_3</v-icon> 12ª classe</v-btn>
            <v-btn @click="classe(4)" class="ma-2" outlined color="indigo"><v-icon small color="primary">filter_4</v-icon> 13ª classe</v-btn>
          </v-col>

          <v-col cols="3" sm="3" md="3">
            <v-select :items="Listaranoslectivo" v-model="anolectivoSelected" item-value="descricao"
              item-text="novadescricao" label="Selecione o Ano lectivo" @change="filtrarAnoLectivo()" return-object>
            </v-select>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <!--====== FIM CARD PRINCÍPAL EXIBIDO NA TELA ==========-->
  </div>
</template>

<script>
import axios from '../../../plugins/axios'
const ls = require('local-storage')
import loading from "../../../components/loading.vue";
import Swal from "sweetalert2";
export default {
  components: {
    loading
  },
  data: () => ({
    anolectivoSelected: ls.get('anolectivo'),
    Listaranoslectivo: [],
    roles: 'func',
    isLoading: false
  }),

  computed: {
    idclasse() {
      return this.$store.state.idclasse
    }
  },

  created() {
    try {
      if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
      if (!this.$store.state.turmaPage) {
        this.$router.push('/turma/menu')
      } else {
        this.initializeAnosLectivo()
        // Seta o anolectivo padrão
        this.$store.state.anolectivoSelecionado = this.anolectivoSelected
        this.$store.state.novadescricaoSelecionado = ls.get('novadescricao')
        this.$store.state.idclasse = null
      }
    } catch (error) {
      Swal.fire("Informação", "<p>Erro ao inicializar a página!</p>", "error");
    }
  },

  methods: {
    // Esta função é responsável por salvar a classe selecionada.
    // A classe selecionada é salva em uma variável global que será usada na próxima página (/turma/listagem)
    classe(idclasse) {
      this.isLoading = true;
      try {
        const ls = require('local-storage')
        this.$store.state.idclasse = idclasse
        if (idclasse === 1) {
          this.$store.state.classeTur = '10ªC-' + ls.get('anolectivo')
        } else if (idclasse === 2) {
          this.$store.state.classeTur = '11ªC-' + ls.get('anolectivo')
        } else if (idclasse === 3) {
          this.$store.state.classeTur = '12ªC-' + ls.get('anolectivo')
        } else if (idclasse === 4) {
          this.$store.state.classeTur = '13ªC-' + ls.get('anolectivo')
        }

        this.$router.push(this.$store.state.turmaPage)
      } catch (error) {
        Swal.fire("Informação", "<p>Erro ao selecionar a classe!</p>", "error");
      } finally {
        this.isLoading = false;
      }
    },

    // Esta função é responsável por salvar o ano lectivo secionado.
    // O ano lectivo é salvo em uma variável global que será usada na próxima página.
    filtrarAnoLectivo() {
      this.$store.state.anolectivoSelecionado = this.anolectivoSelected.descricao
      this.$store.state.novadescricaoSelecionado = this.anolectivoSelected.novadescricao
    },

    // Esta função é responsável por inicializar a lista de anos letivos.
    // Está lista é exibida em uma combobox na tela
    async initializeAnosLectivo() {
      this.isLoading = true;
      try {
        this.Listaranoslectivo = await axios.get('/listarAnoLectivoAll').then(res => res.data)
      } catch (error) {
        Swal.fire("Informação", "<p>Erro ao carregar os anos lectivos!</p>", "error");
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>
